<template>
  <div class="table-tr">
    <div class="table-td cell-availability" :class="{ 'transparent-indicator-red': !inPast, 'indicator-background-grey': inPast }">
      <div class="availability-date">
        <div>
          <span>
            <strong>
              {{ __('Holiday') }} {{ item.date }}
            </strong>
          </span>
        </div>
      </div>
    </div>

    <div class="table-td cell-availability indicator-background-grey">
      <div class="availability-date">
      </div>
    </div>

    <div class="table-td cell-availability">
      <div class="availability-time">
        <strong>
          {{ __choice("{0} :days days|{1} :days day|[2,4] :days days|[5,*] :days days", item.duration, { 'days': item.duration }) }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    computed: {
      inPast() {
        return this.type === 'older'
      }
    }
  }
</script>
